export const COLORS = {
  BRAND_PRIMARY: '#111827',
  BRAND_SECONDARY: '#EDEDED',
  TEXT_INVERSE: '#ffffff',
  DISABLED_DARK: '#6b7280',
  DISABLED_LIGHT: '#d1d5db',
};
